function addAncestors(nodes, parentCodes = []) {
    return nodes.map((node) => {
        // Ajouter les codes des parents actuels à l'objet courant
        const updatedNode = {
            ...node,
            ancestors: [...parentCodes],
        };

        // Si le noeud a des enfants, on les traite récursivement
        if (node.children && Array.isArray(node.children)) {
            updatedNode.children = addAncestors(node.children, [...parentCodes, node.code]);
        }

        return updatedNode;
    });
}

export const applyChildAncestorsProp = (nodes) => {
    return addAncestors(nodes);
};
